module.exports = __webpack_public_path__ + "media/images/iconTrendDown__okGreen--dark-e384801c1778ba81690eb6809d20d28c.png";